/* =========================================================
SHARED TRAVEL-SIZE LINKS

The Travel variant has no selling plan, so a page that server-renders on it
gets a Loop widget with no subscribe card - the script below bails on that,
the size dropdown never mounts, and the shopper is stuck on Travel. So a
shared ?variant=<travel> link is redirected to the main variant, with the
Travel id carried in TRAVEL_PARAM, and applySharedTravelSelection() picks it
once the widget is up.

Runs at module top level so it does not wait on the Loop widget poll. No
redirect loop: the target's ?variant= is the main id, which is not listed.
========================================================= */
const TRAVEL_VARIANT_REDIRECTS = [
   { travel: 54101311029432, main: 54101390819512 },
   { travel: 54101188280504, main: 54101348647096 },
   { travel: 54101299757240, main: 54101350973624 },
];
const TRAVEL_PARAM = "travel";

(function redirectSharedTravelLink() {
  const url = new URL(location.href);
  const variantId = url.searchParams.get("variant");
  if (!variantId) return;

  const entry = TRAVEL_VARIANT_REDIRECTS.find(pair => String(pair.travel) === variantId);
  if (!entry) return;

  // everything else on the link (utm etc.) is kept
  url.searchParams.set("variant", String(entry.main));
  url.searchParams.set(TRAVEL_PARAM, String(entry.travel));

  // replace, so Back does not land on the Travel URL and bounce again
  location.replace(url.toString());
})();

document.addEventListener("DOMContentLoaded", function() {
  console.log('%cLoop custom logics', 'background:#000;color:#fff;', "Init");

  // 🔁 Wait for Loop widget
  function waitForLoopWidget(callback) {
    const checkExist = setInterval(() => {
      const loopContainer = document.querySelector(".loop-widget-container");
      const hasOptions = loopContainer && loopContainer.querySelectorAll(".loop-widget-purchase-option").length > 0;
      if (hasOptions) {
        clearInterval(checkExist);
        callback(loopContainer);
      }
    }, 250);
  }

  waitForLoopWidget(loopContainer => {
    const productType = window.productPurchaseType || "Single";
    // Single products only: fewest units a subscription can be bought in
    // (custom.subscription_min_qty, see main-product.liquid)
    const subMinQty = parseInt(window.productSubMinQty, 10) || 5;
    console.log('%cLoop custom logics', 'background:#000;color:#fff;', "Loop widget found -", productType);

    // --- "bundle with 3 gifts" config (edit copy / gifts / colours here) ---
    const THREE_GIFTS_CONFIG = {
      // the 3 free gifts. `value` is the gift MSRP - it is added to the
      // struck-through subscribe price and shown on the row.
      gifts: [
        {
          src: "https://cdn.shopify.com/s/files/1/0893/2746/8728/files/bathheadband.png?v=1783532543",
          title: "Headband",
          subtitle: "",
          value: 8
        },
        {
          src: "https://cdn.shopify.com/s/files/1/0893/2746/8728/files/2048x2048-STICKERPACK-1.png?v=1783530510",
          title: "Sticker Set",
          subtitle: "",
          value: 2
        },
        {
          src: "https://cdn.shopify.com/s/files/1/0893/2746/8728/files/eBook-RiniReport.png?v=1789451638",
          title: "Rini Reports E-Book",
          subtitle: "A Science-Backed Parent's Guide To Personal Care For Kids",
          value: 5
        }
      ],
      // add the gift MSRPs to the struck-through subscribe price
      addGiftValueToComparePrice: true,
      recurringDiscountPercent: 25,     // used in the first bullet
      bestValueText: "Best Value",
      freeLabel: "FREE",
      giftsBulletHtml: `<b>3 FREE</b> gifts with first subscription order`,
      cancelBulletHtml: `Skip, pause, or cancel anytime`,
      currencyFallback: "$",
      accentColor: "#D8F27B",
      barColor: "#1C1C1C"
    };

    // accept both the slug and the human-readable spelling
    const isThreeGifts = productType === "bundle-with-3-gifts" || productType === "Bundle with 3 gifts";

    const oneTimeOption = loopContainer.querySelector(".loop-widget-purchase-option-onetime");
    const subOption = loopContainer.querySelector('[data-loop-widget-selling-plan-group]');
    let qtyInput = Array.from(document.querySelectorAll('input[name="quantity"]'))
      .find(input => input.offsetParent !== null); // ✅ visible input only

    if (!oneTimeOption || !subOption || !qtyInput) {
      console.log('%cLoop custom logics', 'background:#000;color:#fff;', "No payment options found");
      return;
    }

    /* =========================================================
    VARIANT DROPDOWN (one-time card)

    Size only means something for a one-time buy - subscriptions are always
    the first ("Standard") variant - so the picker moves inside the one-time
    card and the theme's own swatches are hidden.

    Data comes from variant-dropdown-data.liquid, rendered into the same form
    as the widget and gated on custom.variant_selector. No script, or
    fewer than two variants, and every function here is a no-op.
    ========================================================= */

    // positional, by variant index - index 2+ falls back to the variant title
    const VARIANT_LABELS = ["Standard", "Travel"];
    const VARIANT_LABEL_GAP = " ";          // em space, approximates the mock's columns
    const VARIANT_SOLD_OUT_SUFFIX = " — sold out";

    // the sold-out case: strict index 0 as specified, even when unavailable.
    // Flip to true to prefer the first purchasable variant instead.
    const SUBSCRIPTION_PREFERS_AVAILABLE = false;

    const loopForm = loopContainer.closest("form")
      || Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
        .find(form => form.contains(loopContainer));

    const variantDataEl = loopForm && loopForm.querySelector('[id^="variant-dropdown-data-"]');

    let variantData = null;

    if (variantDataEl) {
      try {
        variantData = JSON.parse(variantDataEl.textContent);
      } catch (err) {
        console.warn('%cLoop custom logics', 'background:#000;color:#fff;', "Bad variant data", err);
      }
    }

    const variantSelectEnabled = !!(variantData && variantData.variants && variantData.variants.length > 1);

    // set window.RINI_VARIANT_DEBUG = true in the console to trace the chain
    const vsLog = (...args) => {
      if (window.RINI_VARIANT_DEBUG) console.log('%cvariant-select', 'background:#06c;color:#fff;', ...args);
    };

    vsLog("init", {
      loopForm: !!loopForm,
      dataScript: !!variantDataEl,
      enabled: variantSelectEnabled,
      variants: variantData && variantData.variants && variantData.variants.length,
      optionsId: variantData && variantData.options_id
    });

    // --- Money helpers (used by the 3-gift pricing) ---
    const MONEY_RE = /(?:[$\u00A3\u20AC\u20B9\u00A5]|\b(?:USD|CAD|AUD|NZD|EUR|GBP|INR)\b)\s*\d[\d.,]*/;

    function parseMoney(text) {
      const match = String(text || "").match(MONEY_RE);
      if (!match) return null;

      const raw = match[0];
      const numeric = raw.replace(/[^\d.,]/g, "").replace(/,(?=\d{3}\b)/g, "");
      const amount = parseFloat(numeric.replace(/,/g, "."));
      if (isNaN(amount)) return null;

      return { amount, symbol: raw.replace(/[\d.,\s]/g, "") };
    }

    function formatMoney(amount, symbol, compact) {
      const sym = symbol || THREE_GIFTS_CONFIG.currencyFallback;
      const value = compact && Math.round(amount * 100) % 100 === 0
        ? String(Math.round(amount))
        : amount.toFixed(2);
      return `${sym}${value}`;
    }

    // one decimal, but 25.0 -> 25
    const formatPercent = pct => String(Math.round(pct * 10) / 10);

    const giftsTotal = THREE_GIFTS_CONFIG.gifts
      .reduce((sum, gift) => sum + (Number(gift.value) || 0), 0);

    // --- Helpers ---
    const hide = el => { if (el) el.style.display = "none"; };
    const show = el => { if (el) el.style.display = ""; };
    const selectOption = el => {
      if (el && !el.classList.contains("loop-widget-purchase-option-selected")) el.click();
    };

    if (productType == 'Bundle' || productType == 'Starter Bundle' || productType == 'Single' || isThreeGifts) {
      selectOption(subOption);
      const optionsContainer = loopContainer.querySelector(".loop-widget-purchase-options-container");
      if (optionsContainer) {
        optionsContainer.style.display = "flex";
        optionsContainer.style.flexDirection = "column-reverse";
      }
    }


    //inject freegift html and badge
    const freeGift = document.createElement("div");
    freeGift.className = "loop-freegift";
    freeGift.style.display = "none";

    const badge = document.createElement("span");
    badge.className = "loop-badge";
    badge.style.display = "none";

    const headingContainer = document.querySelector('.product-form--block[data-block-type="heading"]');

    if (productType == 'Starter Bundle') {
      freeGift.innerHTML = `
        <div class="text">
          You've unlocked <br/> a free rini headband!
        </div>
        <div class="image">
          <img src="https://cdn.shopify.com/s/files/1/0893/2746/8728/files/freeheadband.png?v=1763036838" />
        </div>
      `;
      loopContainer.appendChild(freeGift);

      badge.textContent = '33% off';
      headingContainer.appendChild(badge);


      //add 33% off badge
      const badgeWrapper = subOption.querySelector('.loop-widget-spg-label-discount-wrapper');
       const offbadge = document.createElement('div');
       offbadge.textContent = '33% off';

       offbadge.style.borderRadius = '30px';
       offbadge.style.background = '#EDF9B3';
       offbadge.style.padding = '2px 7px';
       offbadge.style.fontWeight = '500';

       badgeWrapper.appendChild(offbadge);
    }

    // "SAVE x%" / "BEST VALUE" bar that sits on top of the subscribe card
    const giftsTopBar = document.createElement("div");
    giftsTopBar.className = "loop-gifts-topbar";

    const giftsSaveEl = document.createElement("div");
    giftsSaveEl.className = "loop-gifts-save";

    const giftsBestEl = document.createElement("div");
    giftsBestEl.className = "loop-gifts-best";
    giftsBestEl.textContent = THREE_GIFTS_CONFIG.bestValueText;

    giftsTopBar.appendChild(giftsSaveEl);
    giftsTopBar.appendChild(giftsBestEl);

    /* The variant dropdown is built once and re-seated on every update, so its
       listeners are bound here and never re-bound - see mountVariantSelect(). */
    /* A fieldset so the option name notches into the border, matching Loop's
       own frequency selector. The native <select> is kept for interaction (and
       the native picker on mobile) but laid over the box at zero opacity: a
       closed select renders its label at one weight, and the design needs the
       size name bolder than its measurements. */
    const variantWrap = document.createElement("fieldset");
    variantWrap.className = "loop-variant-select-wrapper";

    const variantLegend = document.createElement("legend");
    variantLegend.className = "loop-variant-select-legend";

    const variantDisplay = document.createElement("div");
    variantDisplay.className = "loop-variant-select-display";
    variantDisplay.setAttribute("aria-hidden", "true");

    let pendingVariantId = null;
    let pendingTimer = null;

    /* Whether the settling pick came from the dropdown. Only then should the
       one-time card be put back if Loop re-renders onto its default - a variant
       forced BY subscribe must stay on subscribe, or the two guards undo each
       other and the first tap on subscribe appears to do nothing. */
    let pendingFromDropdown = false;

    const variantSelect = document.createElement("select");
    variantSelect.className = "loop-variant-select";
    variantSelect.setAttribute("aria-label", "Size");

    if (variantSelectEnabled) {
      variantData.variants.forEach((variant, index) => {
        const option = document.createElement("option");
        const label = VARIANT_LABELS[index];

        option.value = String(variant.id);
        option.textContent = (label ? label + VARIANT_LABEL_GAP : "")
          + variant.title
          + (variant.available ? "" : VARIANT_SOLD_OUT_SUFFIX);

        option.disabled = !variant.available;   // listed, but not selectable
        variantSelect.appendChild(option);
      });

      // match Loop's own frequency select where it exists; additive, so our
      // class still carries the styling if Loop renames theirs
      const loopSelect = loopContainer.querySelector(".loop-widget-spg-container select");
      if (loopSelect) variantSelect.className += " " + loopSelect.className;

      variantLegend.textContent = (variantData.options[0] && variantData.options[0].name) || "Size";

      variantWrap.appendChild(variantLegend);
      variantWrap.appendChild(variantDisplay);
      variantWrap.appendChild(variantSelect);

      variantSelect.addEventListener("change", () => {
        updateVariantDisplay();
        selectVariantById(variantSelect.value, true);
      });

      variantSelect.addEventListener("click", event => event.stopPropagation());

      updateVariantDisplay();
    }

    if (isThreeGifts) {
      freeGift.classList.add("loop-freegift--triple");
      freeGift.innerHTML = THREE_GIFTS_CONFIG.gifts.map(gift => `
        <div class="loop-gift-row">
          <div class="loop-gift-media"><img src="${gift.src}" alt="${gift.title || ''}" /></div>
          <div class="loop-gift-info">
            <div class="loop-gift-head">
              <span class="loop-gift-free">${THREE_GIFTS_CONFIG.freeLabel}</span>
              ${gift.value ? `<span class="loop-gift-value">${formatMoney(Number(gift.value), THREE_GIFTS_CONFIG.currencyFallback, true)}</span>` : ``}
            </div>
            <div class="loop-gift-title">${gift.title || ''}</div>
            ${gift.subtitle ? `<div class="loop-gift-sub">${gift.subtitle}</div>` : ``}
          </div>
        </div>
      `).join("");
    }
 

    // Bullets for the 3-gift subscribe option. Both percentages are null until
    // the widget prices have been read, so the copy degrades gracefully.
    // `savePct` is measured against the compare-at price PLUS the gift value
    // (first order only); `recurringPct` against the compare-at price alone.
    function buildGiftsSubDesc(savePct, recurringPct) {
      const cfg = THREE_GIFTS_CONFIG;
      const recurring = recurringPct == null
        ? cfg.recurringDiscountPercent
        : formatPercent(recurringPct);

      const firstBullet = savePct == null
        ? `Save ${recurring}% off every order`
        : `Save ${formatPercent(savePct)}% off your first order, ${recurring}% off recurring`;

      return `<ul class="loop-desc">
          <li>${firstBullet}</li>
          <li>${cfg.cancelBulletHtml}</li>
          <li>${cfg.giftsBulletHtml}</li>
        </ul>`;
    }

    // --- Descriptions (based on product type) ---
    let subDesc = "";
    let oneTimeDesc = "";

    /* The fixed lines under the one-time card. The discount lines above them
       carry live figures and are rebuilt by updateOneTimeDesc(). */
    let oneTimeBullets = "";

    // Single is not a bundle, so it gets no "% off ... of bundle" line
    const showsBundleDiscount = productType !== "Single";

    /* One-time bullets, live figures first:
         - the real discount on the one-time row, for every bundle
         - what subscribing would add, and the gifts, for the 3-gift bundle only
       A percentage that cannot be read yet drops its line rather than printing
       a placeholder. */
    function buildOneTimeDesc(oneTimePct, recurringPct) {
      let items = "";

      if (showsBundleDiscount && oneTimePct != null) {
        items += `<li>${formatPercent(oneTimePct)}% off one-time purchase of bundle</li>`;
      }

      /*
      if (isThreeGifts) {
        if (recurringPct != null) {
          items += `<li class="no">No additional bundle discount of ${formatPercent(recurringPct)}% off</li>`;
        }
        items += `<li class="no">No free gifts</li>`;
      }
      */

      items += oneTimeBullets;

      return items ? `<ul class="loop-desc">${items}</ul>` : "";
    }

    /* Single subscribe discount. The selling plan's own percentage comes from
       main-product.liquid (window.productSubDiscountPct); when the plan is not a
       plain percentage it is measured off the widget instead, subscribe unit
       price against one-time price. Null until either is known, and the line
       drops rather than printing a placeholder. */
    const planSubDiscountPct = parseFloat(window.productSubDiscountPct);

    function singleSubDiscountPct() {
      if (planSubDiscountPct > 0) return planSubDiscountPct;
      if (bundlePricesOwned()) return null;   // rows hold pack totals, not unit prices

      const oneTime = readOptionPrices(oneTimeOption).current;
      const sub = readUnitMoney(loopPriceOf(subOption));   // not the qty total we write

      if (!oneTime || !sub || !oneTime.money.amount) return null;
      if (sub.amount >= oneTime.money.amount) return null;

      return (1 - sub.amount / oneTime.money.amount) * 100;
    }

    function buildSingleSubDesc(pct) {
      const saveLine = pct == null ? "" : `<li>save ${formatPercent(pct)}% off every month</li>`;

      return `<ul class="loop-desc">
          <li>buy ${subMinQty}+ to subscribe</li>
          ${saveLine}
          <li>skip, pause, or cancel anytime</li>
        </ul>`;
    }

    // idempotent: this sits inside the widget, so a blind write would feed
    // the MutationObserver that calls us
    function updateSingleSubDesc() {
      if (productType !== "Single") return;

      const html = buildSingleSubDesc(singleSubDiscountPct());
      if (subDescEl.innerHTML !== html) subDescEl.innerHTML = html;
    }

    if (productType === "Single") {
      qtyInput.value = subMinQty;
      qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));

      // For single SKU - the "save" line carries the live figure, see
      // updateSingleSubDesc(). Plan figure only here: the price readers it
      // measures with are declared further down.
      subDesc = buildSingleSubDesc(planSubDiscountPct > 0 ? planSubDiscountPct : null);
      oneTimeDesc = ""; // optional – no one-time description for singles
    }

    else if (productType === "Starter Bundle") {
      subDesc = `<ul class="loop-desc">
          <li>2 hydrogel facial masks shipped monthly</li>
          <li>3 everyday facial sheet masks shipped monthly</li>
          <li><b>free</b> rini headband one-time shipment</li>
          <li>pause, cancel, or adjust at anytime</li>
        </ul>`;
      oneTimeBullets = `<li>2 hydrogel facial masks</li>
          <li>3 everyday facial sheet masks</li>
          <li class="no">no free headband</li>`;
    }

    else if (productType === "Bundle") {
      subDesc = `<ul class="loop-desc">
          <li>save an additional 10% off every month</li>
          <li>skip, pause, or cancel anytime</li>
        </ul>`;
      oneTimeDesc = ``;
    }

    else if (isThreeGifts) {
      // the first bullet carries the live "save x%" figure - see updateGiftPricing()
      subDesc = buildGiftsSubDesc(null);
      oneTimeDesc = "";
    }

    else if (productType === "Bundle with subscription only") {
      subDesc = ``;
      oneTimeDesc = "";
    }

    // --- Create elements (shared logic) ---
    // the percentages are unknown until the widget has rendered its prices, so
    // the first paint carries the static lines only - updateOneTimeDesc() fills
    // the rest in on the first updateOptions() pass
    oneTimeDesc = buildOneTimeDesc(null, null);

    const oneTimeDescEl = document.createElement("div");
    oneTimeDescEl.innerHTML = oneTimeDesc;
    oneTimeDescEl.classList.add("loop-desc-wrapper");

    const subDescEl = document.createElement("div");
    subDescEl.innerHTML = subDesc;
    subDescEl.classList.add("loop-desc-wrapper");

    // --- Shared styles ---
    const style = document.createElement("style");
    style.textContent = `
      .loop-widget-purchase-options-container {
        gap:10px!important;
      }

      .loop-widget-spg-container {
        margin-left:0px!important;
      }

      /* Loop hides the frequency picker from its own click handling, so a
         programmatic switch to one-time (applySharedTravelSelection, straight
         after the initial subscribe pick) can leave it showing on the
         unselected card. Tie it to the selected class instead. Scoped to the
         widget: mobile-buy-drawer.js moves this node into the drawer for its
         subscribe view, and there it must stay visible. !important beats any
         inline display Loop leaves behind. */
      .loop-widget-container [data-loop-widget-selling-plan-group]:not(.loop-widget-purchase-option-selected) .loop-widget-spg-container {
        display:none!important;
      }

      .loop-widget-container .loop-desc-wrapper {
        margin-left: 2em;
        width: fill-available;
        font-size:13px;
        line-height:1.5;
        align-self: flex-start;
        display:none;
      }

      .loop-widget-purchase-option-selected .loop-desc-wrapper{
        display:block;
      }
      
      .loop-widget-container .loop-desc li {
        padding-left:20px;
        position: relative;
        margin-top:5px;
        font-weight: 500;
        text-align:left;
        font-size:12px;
      }

      
      .loop-widget-container .loop-desc li::before {
        content: url(check.svg);
        position: absolute;
        left: 0;
        top: 0;
      }

      /* li.no, not .no - the class is on the list item, not the list */
      .loop-widget-container .loop-desc li.no::before {
          content: url(Union.svg);
      }

      /* ----- bundle with 3 gifts ----- */
      .loop-widget-container .loop-gifts-topbar {
        display: none;
        align-items: stretch;
        width: 100%;
        flex: 0 0 100%;
        box-sizing: border-box;
        order: -1;
        overflow: hidden;
        border-radius: 0px;
        margin-bottom: 12px;
        font-size: 11px;
        letter-spacing: .06em;
        text-transform: uppercase;
        line-height: 1.2;
      }

      .loop-widget-container .loop-widget-purchase-option-selected .loop-gifts-topbar {
        display:flex;
      }

      /* the .mobile-drawer halves style the same markup after
         mobile-buy-drawer.js clones it into the drawer */
      .loop-widget-container .loop-gifts-save,
      .mobile-drawer .loop-gifts-save {
        flex: 1 1 auto;
        background: ${THREE_GIFTS_CONFIG.barColor};
        color: #fff;
        font-weight: 500;
        padding: 9px 14px;
        text-align: left;
      }

      .loop-widget-container .loop-gifts-save b,
      .mobile-drawer .loop-gifts-save b { font-weight: 700; }

      .loop-widget-container .loop-gifts-best,
      .mobile-drawer .loop-gifts-best {
        flex: 0 0 auto;
        background: ${THREE_GIFTS_CONFIG.accentColor};
        color: ${THREE_GIFTS_CONFIG.barColor};
        font-weight: 600;
        padding: 9px 18px;
        text-align: center;
      }

      /* Desktop: one gift per row, image beside the caption. The phone layout
         (three across, image over caption) is the override at 767px below.
         The container stays a grid in both, because updateGiftsBasedOnSelection()
         sets display:grid inline and an inline style would beat a flex rule. */
      .loop-widget-container .loop-freegift--triple,
      .mobile-drawer .loop-freegift--triple {
        display: none;
        grid-template-columns: 1fr;
        gap: 8px;
        width: 100%;
        flex: 0 0 100%;
        box-sizing: border-box;
        margin: 10px 0 4px;
      }

      .loop-widget-container .loop-freegift--triple .loop-gift-row,
      .mobile-drawer .loop-gift-row {
        display: grid;
        grid-template-columns: 92px 1fr;
        gap: 14px;
        align-items: center;
        min-width: 0;
        background: #FAF7EF;
        border-radius: 6px;
        padding: 0px 14px 0px 0;
        text-align: left;
      }

      .loop-widget-container .loop-freegift--triple .loop-gift-media,
      .mobile-drawer .loop-gift-media {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px;
      }

      .loop-widget-container .loop-freegift--triple .loop-gift-media img,
      .mobile-drawer .loop-gift-media img {
        width: 100%;
        max-height: 72px;
        object-fit: contain;
        display: block;
      }

      .loop-widget-container .loop-freegift--triple .loop-gift-head,
      .mobile-drawer .loop-gift-head {
        font-size: 13px;
        font-weight: 700;
        line-height: 1.35;
      }

      .loop-widget-container .loop-freegift--triple .loop-gift-value,
      .mobile-drawer .loop-gift-value {
        font-weight: 500;
        text-decoration: line-through;
        opacity: .5;
        margin-left: 4px;
      }

      .loop-widget-container .loop-freegift--triple .loop-gift-title,
      .mobile-drawer .loop-gift-title {
        font-size: 13px;
        font-weight: 500;
        line-height: 1.35;
      }

      .loop-widget-container .loop-freegift--triple .loop-gift-sub,
      .mobile-drawer .loop-gift-sub {
        font-size: 12px;
        font-weight: 400;
        line-height: 1.35;
        opacity: .8;
        margin-top: 2px;
      }

      /* compare-at price injected when the widget renders no struck price, and
         the widget's own compare-at node once unhidden. The drawer clones the
         price container into its header, so it needs the same treatment. */
      .loop-widget-container .loop-gifts-compare,
      .loop-widget-container .loop-gifts-compare--revealed,
      .mobile-drawer .loop-gifts-compare,
      .mobile-drawer .loop-gifts-compare--revealed {
        text-decoration: line-through;
        opacity: .55;
        margin-right: 6px;
      }

      /* Phone: the three gifts go side by side, image over caption. A third of
         the width has no room for the subtitle, and a long title is clamped. */
      @media (max-width: 767px) {
        .loop-widget-container .loop-freegift--triple,
        .mobile-drawer .loop-freegift--triple {
          grid-template-columns: repeat(3, minmax(0, 1fr));
        }

        .loop-widget-container .loop-freegift--triple .loop-gift-row,
        .mobile-drawer .loop-gift-row {
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 10px 10px 12px;
        }

        .loop-widget-container .loop-freegift--triple .loop-gift-media,
        .mobile-drawer .loop-gift-media {
          padding: 0;
        }

        /* a fixed height rather than a cap, so the three images line up */
        .loop-widget-container .loop-freegift--triple .loop-gift-media img,
        .mobile-drawer .loop-gift-media img {
          height: 88px;
          max-height: none;
        }

        .loop-widget-container .loop-freegift--triple .loop-gift-title,
        .mobile-drawer .loop-gift-title {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .loop-widget-container .loop-freegift--triple .loop-gift-sub,
        .mobile-drawer .loop-gift-sub {
          display: none;
        }

        .loop-widget-container .loop-freegift--triple .loop-gift-info,
        .mobile-drawer .loop-gift-info {
          text-align: center;
        }
      }

      @media (max-width: 480px) {
        .loop-widget-container .loop-freegift--triple,
        .mobile-drawer .loop-freegift--triple {
          gap: 6px;
        }

        .loop-widget-container .loop-freegift--triple .loop-gift-row,
        .mobile-drawer .loop-gift-row {
          padding: 0px 8px 10px;
          gap: 6px;
        }

        .loop-widget-container .loop-freegift--triple .loop-gift-head,
        .loop-widget-container .loop-freegift--triple .loop-gift-title,
        .mobile-drawer .loop-gift-head,
        .mobile-drawer .loop-gift-title {
          font-size: 12px;
        }
      }
    `;
    if (!document.getElementById("loop-custom-style")) {
      style.id = "loop-custom-style";
      document.head.appendChild(style);
    }


    oneTimeOption.appendChild(oneTimeDescEl);
    subOption.appendChild(subDescEl);
    const spgContainer = subOption.querySelector(".loop-widget-spg-container .loop-widget-sp-selector-label-as-text");
    if (spgContainer) spgContainer.style.display = "none";

    if (isThreeGifts) {
      // order inside the subscribe card: bar, label + price, bullets, gifts, frequency
      const frequencyContainer = subOption.querySelector(".loop-widget-spg-container");
      if (frequencyContainer) {
        subOption.insertBefore(subDescEl, frequencyContainer);
        subOption.insertBefore(freeGift, frequencyContainer);
      } else {
        subOption.appendChild(freeGift);
      }
    }

    /* The bar tops the subscribe card on every product type. Loop rebuilds the
       option's contents on its own (a re-render, a plan change, bundleSelector
       rewriting the prices), which drops anything we injected - so this is
       re-seated on every update rather than inserted once. The guard keeps it
       from mutating the DOM when it is already in place, which would feed the
       MutationObserver below straight back into another update. */
    function mountTopBar() {
      if (subOption.firstChild === giftsTopBar) return;

      subOption.insertBefore(giftsTopBar, subOption.firstChild);
    }

    mountTopBar();

    /* Same re-seat pattern, same reason: Loop rebuilds the one-time card and
       drops whatever we appended. The guard is what keeps this from feeding
       the MutationObserver back into another update. */
    function mountVariantSelect() {
      if (!variantSelectEnabled) return;
      if (oneTimeOption.lastElementChild === variantWrap) return;

      oneTimeOption.appendChild(variantWrap);
    }

    function currentVariantId() {
      const input = loopForm && loopForm.querySelector('input[name="id"]');
      return input && input.value ? String(input.value) : null;
    }

    /* Drive the theme's own picker. This is by far the best path: one synthetic
       change gives the whole correct chain - section refetch, ?variant= in the
       URL, and variantChanged, which is what sets input[name="id"] AND its
       data-management / data-policy / data-quantity. Utils.getQuantity gates
       add-to-cart on those attributes, not on the value.

       Two traps. ProductOptions replaces itself via outerHTML, so the picker is
       re-queried every call rather than cached. And the picker is hidden on
       these products, so its Disclosure never bound its click handlers via
       IntersectionObserver - dispatching change on the input works regardless,
       clicking the UI would not. */
    function driveThemePicker(variant) {
      const picker = document.querySelector("product-options-element");

      if (!picker || !variantData.options.length) {
        vsLog("no picker", { picker: !!picker, options: variantData.options.length });
        return false;
      }

      const inputs = [];

      variantData.options.forEach((option, index) => {
        const wanted = variant.options[index];
        const match = option.values.find(value => value.value === wanted);
        if (!match || !match.id) return;

        /* Swatches and radios render one input per value, and
           setCurrentOptions() reads [data-item="radio"]:checked - so check the
           one we want and the browser unchecks its sibling. */
        const radio = picker.querySelector(
          '[data-item="radio"][data-option-value-id="' + match.id + '"]'
        );

        if (radio) {
          radio.checked = true;
          inputs.push(radio);
          return;
        }

        /* The disclosure style renders ONE hidden input per option, holding
           whichever value is current - so there is nothing to check, the
           attributes are rewritten in place instead. setCurrentOptions() reads
           every [data-item="disclosure"] regardless of state. */
        const disclosure = picker.querySelector(
          '[data-item="disclosure"][data-option-name="'
          + String(option.name).trim().toLowerCase() + '"]'
        );

        if (!disclosure) return;

        disclosure.value = match.value;
        disclosure.setAttribute("data-option-value-id", match.id);
        disclosure.setAttribute("data-product-url", match.product_url || "");

        inputs.push(disclosure);
      });

      if (!inputs.length) {
        vsLog("picker matched nothing", {
          wanted: variant.options,
          known: variantData.options.map(o => o.values.map(v => v.value))
        });
        return false;
      }

      // set every option first, then fire once - otherwise a multi-option
      // product kicks off one section refetch per option
      inputs[inputs.length - 1].dispatchEvent(new Event("change", { bubbles: true }));

      return true;
    }

    /* Only for a page with no picker rendered. Setting the five data
       attributes matters as much as the value - a stale data-quantity blocks
       add-to-cart silently. */
    function applyVariantFallback(variant) {
      const input = loopForm && loopForm.querySelector('input[name="id"]');

      if (input) {
        input.value = variant.id;
        input.setAttribute("data-id", variant.id);
        input.setAttribute("data-sku", variant.sku || "");
        input.setAttribute("data-management", variant.inventory_management || "");
        input.setAttribute("data-policy", variant.inventory_policy || "");
        input.setAttribute("data-quantity", variant.inventory_quantity || 0);
      }

      window.dispatchEvent(new CustomEvent(
        "theme:product:" + variantData.options_id + ":variantChanged",
        { detail: { variant } }
      ));
    }

    /* The galleries live in a different section from the buy box, so they carry
       a different data-id namespace - and nothing on the page ever fires on it,
       because ProductOptions only emits on its own. Without this the image
       never follows the variant.

       Namespaces are read off the DOM rather than hardcoded, so renaming the
       section cannot silently break it, and the SECONDARY_GALLERY scoping keeps
       the metafield galleries out of range - their media carry non-numeric ids,
       so a variantChanged there blanks them. */

    /* The metafield-backed galleries: the one-time/subscribe swap
       (data-type="optional") and the Travel size (data-type="travel"). Both are
       built from file references, so their media ids are strings like
       "travel-image-0" and none of the media-id machinery below applies to
       them. Anything walking the real gallery must skip both. */
    const SECONDARY_GALLERY = '[data-type="optional"], [data-type="travel"]';

    const GALLERY_SCOPE = '.main-product--desktop:not([data-type="optional"]):not([data-type="travel"]), '
      + '.main-product--mobile:not([data-type="optional"]):not([data-type="travel"])';

    function broadcastToGalleries(variant) {
      const namespaces = new Set();

      document.querySelectorAll(GALLERY_SCOPE).forEach(scope => {
        scope.querySelectorAll("product-media-variants, product-thumbs-element").forEach(el => {
          if (el.dataset.id) namespaces.add(el.dataset.id);
        });
      });

      namespaces.delete(variantData.options_id);   // the picker chain covers that one

      /* ProductMedia only acts on variant.featured_media.id - a variant with no
         image of its own gives it nothing to switch to. */
      vsLog("gallery broadcast", {
        namespaces: [...namespaces],
        media: variant.featured_media && variant.featured_media.id
      });

      namespaces.forEach(namespace => window.dispatchEvent(new CustomEvent(
        "theme:product:" + namespace + ":variantChanged",
        { detail: { variant } }
      )));
    }

    /* Loop repaints a purchase-option row when it is clicked, not when the
       variant changes underneath it - so after a pick the one-time row keeps
       quoting the old size, and both struck prices stay on the old compare-at.
       (The subscribe price does follow: Loop derives it from the new variant.)

       The exact figures are already in the Liquid data, so they are written in
       the same way bundleSelector.js writes pack totals. Writes are skipped
       when unchanged: loop-custom-logics watches this widget for mutations, so
       an unconditional write would feed its own observer forever. */
    const loopPriceOf = option => option.querySelector(".loop-widget-purchase-option-price");
    const loopStruckOf = option => option.querySelector(".loop-widget-purchase-option-compare-at-price");

    /* Single products quote the subscribe card for the whole quantity, not per
       unit. Loop paints per-unit figures, so the unit is parked on the node
       (data-rini-unit) next to the total written over it (data-rini-total).
       A node still showing the total we wrote reports the parked unit; any
       other text is a fresh Loop paint and is read as the new unit. */
    const subShowsTotals = productType == "Single";

    function subTotalQty() {
      if (!subShowsTotals) return 1;

      const input = Array.from(document.querySelectorAll('input[name="quantity"]'))
        .find(el => el.offsetParent !== null);

      return (input && parseInt(input.value, 10)) || 1;
    }

    function readUnitMoney(el) {
      if (!el) return null;

      const shown = parseMoney(el.textContent);
      if (!shown) return null;

      const unit = parseFloat(el.getAttribute("data-rini-unit"));
      const ours = el.getAttribute("data-rini-total") === el.textContent.trim();

      return ours && !isNaN(unit) ? { amount: unit, symbol: shown.symbol } : shown;
    }

    // idempotent: the widget is watched for mutations, so only a changed
    // figure is written
    function writeSubMoney(el, unit, symbol) {
      if (!el) return;

      const text = formatMoney(unit * subTotalQty(), symbol);

      el.setAttribute("data-rini-unit", String(unit));
      el.setAttribute("data-rini-total", text);
      if (el.textContent.trim() !== text) el.textContent = text;
    }

    /* Loop recomputes its discounted subscribe figure only when its own row is
       clicked, so after a variant change it quotes the previous size. We can't
       read the selling plan's discount, but we can measure it: while nothing is
       in flight, whatever the two rows show IS the ratio. Re-measured on every
       settled pass, so a plan change corrects itself. */
    let subscriptionRatio = null;

    function captureSubscriptionRatio() {
      if (!variantSelectEnabled || pendingVariantId) return;
      if (bundlePricesOwned()) return;   // that ratio would be pack-derived

      const oneTime = parseMoney(loopPriceOf(oneTimeOption) && loopPriceOf(oneTimeOption).textContent);
      const sub = readUnitMoney(loopPriceOf(subOption));   // not the qty total we write

      if (!oneTime || !sub || !oneTime.amount) return;
      if (sub.amount > oneTime.amount) return;          // nonsense, ignore it

      subscriptionRatio = sub.amount / oneTime.amount;
    }

    /* bundleSelector.js writes pack totals into these same rows and watches them
       for changes, exactly as this does. Two writers with different numbers
       trip each other's observers and repaint forever - desktop only, since
       initDesktopBundles is gated to >=768px. On a pack product the pack owns
       the price, so this stands down. */
    function bundlePricesOwned() {
      return !!document.querySelector(".desktop-qty-bundle, .drawer-qty-bundle");
    }

    function renderLoopVariantPrices(variant) {
      if (!variantSelectEnabled || !variant) return;
      if (bundlePricesOwned()) return;

      const setHtml = (el, html) => {
        if (el && el.innerHTML !== html) el.innerHTML = html;
      };

      const money = cents => formatMoney(cents / 100, THREE_GIFTS_CONFIG.currencyFallback);

      /* One-time: the row IS the variant's price, and its struck price is a
         real compare-at, so it shows only when the variant has one. */
      setHtml(loopPriceOf(oneTimeOption), money(variant.price));

      const oneTimeStruck = loopStruckOf(oneTimeOption);
      const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (oneTimeStruck) {
        if (hasCompare) setHtml(oneTimeStruck, money(variant.compare_at_price));
        oneTimeStruck.classList.toggle("loop-display-none", !hasCompare);
      }

      /* Subscribe: its struck price is not a compare-at - it is what the same
         variant costs one-time, which is how the saving reads (Standard showed
         $19.99 struck against $17.99, i.e. 10% off its own price). */
      const subStruck = loopStruckOf(subOption);

      // Single products: renderSubscribeTotals() owns the struck price - it
      // quotes compare-at x qty, and a second writer here would fight it
      if (subStruck && !subShowsTotals) {
        setHtml(subStruck, money(variant.price));
        subStruck.classList.remove("loop-display-none");
      }

      if (subscriptionRatio) {
        writeSubMoney(
          loopPriceOf(subOption),
          Math.round(variant.price * subscriptionRatio) / 100,
          THREE_GIFTS_CONFIG.currencyFallback
        );
      }
    }

    /* restorePurchaseOption() cannot tell Loop resetting its own selection from
       the shopper clicking a card, so an explicit click closes the pending
       window first - otherwise the first tap on subscribe after picking a size
       was simply undone. The timeout is a backstop for the case where the
       theme never reports the new id and pending would otherwise stick. */
    if (variantSelectEnabled) {
      [oneTimeOption, subOption].forEach(option => option.addEventListener("click", event => {
        /* The dropdown sits inside the one-time card, and this listener is on
           the capture phase - so without this guard, opening it counted as
           choosing a purchase option and cancelled the pick that was about to
           happen, leaving the selection to flip back and forth. */
        if (variantWrap.contains(event.target)) return;

        pendingVariantId = null;
        pendingFromDropdown = false;
      }, true));
    }

    function clearPendingLater() {
      clearTimeout(pendingTimer);
      pendingTimer = setTimeout(() => {
        pendingVariantId = null;
        pendingFromDropdown = false;
      }, 4000);
    }

    /* ProductMedia assumes a one-at-a-time gallery: it flips data-active on the
       variant's media, and the theme's CSS only hides the rest in the
       thumbnails/full-screen layouts. With a gallery that shows everything at
       once, that is invisible.

       So the images are filtered instead. Each variant's own featured image is
       treated as belonging to that size and hidden unless the size is selected;
       any media no variant claims is a shared shot and is left alone. */
    const VARIANT_MEDIA_HIDDEN = "rini-variant-media-hidden";

    /* :first-child / :last-child match DOM position, so they stay on a hidden
       image and the gallery loses its end gutters. These mark the first and
       last VISIBLE media instead - customt-form.liquid's gutter rules list them
       alongside the pseudo-classes. */
    const VARIANT_MEDIA_FIRST = "rini-variant-media-first";
    const VARIANT_MEDIA_LAST = "rini-variant-media-last";

    let warnedGalleryConflict = false;

    function filterGalleryMedia(variant) {
      if (!variantSelectEnabled) return;

      const owned = variantData.variants
        .map(v => v.featured_media && v.featured_media.id)
        .filter(Boolean);

      if (!owned.length) return;   // no per-variant images to filter on

      const keep = variant && variant.featured_media ? variant.featured_media.id : null;

      /* Every media element on the page, rather than walking down from a
         gallery container. The desktop gallery is restyled by
         customt-form.liquid and the mobile one has its own wrapper, so each
         container selector tried so far has reached one and missed the other.
         The media classes themselves are the only stable thing.

         The metafield galleries are excluded: their ids are non-numeric
         ("optional-image-0", "travel-image-0"), so they could not match anyway,
         but skipping them explicitly keeps the intent clear. */
      let touched = 0;
      let seen = 0;

      document.querySelectorAll(".product-media--root, .product-media--thumb").forEach(el => {
        if (el.closest(SECONDARY_GALLERY)) return;

        seen++;

        const id = parseInt(el.dataset.id, 10);

        // not a variant's image - a shared shot, leave it visible
        if (!id || owned.indexOf(id) === -1) return;

        el.classList.toggle(VARIANT_MEDIA_HIDDEN, id !== keep);
        touched++;
      });

      markVisibleEnds();

      vsLog("gallery filter", { keep, owned, seen, touched });
    }

    function markVisibleEnds() {
      const containers = new Set();

      document.querySelectorAll(".product-media--root").forEach(el => {
        if (el.closest(SECONDARY_GALLERY)) return;
        if (el.parentElement) containers.add(el.parentElement);
      });

      containers.forEach(parent => {
        const media = Array.from(parent.children)
          .filter(el => el.classList.contains("product-media--root"));

        media.forEach(el => el.classList.remove(VARIANT_MEDIA_FIRST, VARIANT_MEDIA_LAST));

        const visible = media.filter(el => !el.classList.contains(VARIANT_MEDIA_HIDDEN));
        if (!visible.length) return;

        visible[0].classList.add(VARIANT_MEDIA_FIRST);
        visible[visible.length - 1].classList.add(VARIANT_MEDIA_LAST);
      });
    }

    function selectVariantById(id, fromDropdown) {
      if (!variantSelectEnabled) return;

      const variant = variantData.variants.find(v => String(v.id) === String(id));

      // the idempotence guard, measured against the authoritative post-chain
      // value - this is what stops repeated updates from looping
      if (!variant || currentVariantId() === String(variant.id)) {
        vsLog("skipped", { asked: id, found: !!variant, current: currentVariantId() });
        return;
      }

      if (variantSelect.value !== String(variant.id)) {
        variantSelect.value = String(variant.id);
        updateVariantDisplay();       // forcing Standard on subscribe comes through here
      }

      /* Hold the dropdown on the shopper's choice until the theme catches up.
         driveThemePicker kicks off an async section refetch, so for a moment
         input[name="id"] still reads the old variant - without this the next
         updateOptions would call syncVariantSelect and snap the dropdown back. */
      pendingVariantId = String(variant.id);
      pendingFromDropdown = !!fromDropdown;
      clearPendingLater();

      const drove = driveThemePicker(variant);
      if (!drove) applyVariantFallback(variant);

      broadcastToGalleries(variant);
      filterGalleryMedia(variant);
      updateVariantGallery(variant);
      renderLoopVariantPrices(variant);

      /* ProductBuyButtons sets input[name="id"] with a plain assignment and
         never dispatches, so anything listening for a change on it - Loop
         included - hears nothing. Give it the event. */
      const idInput = loopForm && loopForm.querySelector('input[name="id"]');
      if (idInput) {
        idInput.dispatchEvent(new Event("input", { bubbles: true }));
        idInput.dispatchEvent(new Event("change", { bubbles: true }));
      }

      vsLog("selected", { id: variant.id, via: drove ? "theme picker" : "fallback" });
    }

    /* Mirrors the select's current option into the styled box. Built from the
       data rather than the option's own text so the label keeps its weight and
       the sold-out suffix is not repeated in the display. */
    function updateVariantDisplay() {
      if (!variantSelectEnabled) return;

      const index = variantSelect.selectedIndex < 0 ? 0 : variantSelect.selectedIndex;
      const variant = variantData.variants[index];
      if (!variant) return;

      const label = VARIANT_LABELS[index];

      variantDisplay.innerHTML = (label ? '<b class="loop-variant-select-name">' + label + "</b>" : "")
        + '<span class="loop-variant-select-value">' + variant.title + "</span>"
        + '<svg class="loop-variant-select-caret" width="12" height="8" viewBox="0 0 12 8" '
        + 'fill="none" aria-hidden="true"><path d="M1 1.5 6 6.5l5-5" stroke="currentColor" '
        + 'stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    // a property write, invisible to a childList observer
    function syncVariantSelect() {
      if (!variantSelectEnabled) return;

      const id = currentVariantId();
      if (!id) return;

      // a selection is still settling - leave the dropdown on the shopper's pick
      if (pendingVariantId && pendingVariantId !== id) return;

      pendingVariantId = null;
      pendingFromDropdown = false;

      if (variantSelect.value !== id) {
        variantSelect.value = id;
        updateVariantDisplay();
      }
    }

    /* Loop re-renders after the theme's variant refetch and comes back on its
       own default option, which is subscribe. Left alone, enforceSubscription
       Variant then reads that as "the shopper chose subscribe" and hands the
       variant straight back to Standard - so the one-time price never shows the
       new size and the card that visibly repriced is the subscribe one.

       While a pick is still settling, put the one-time card back instead. */
    function restorePurchaseOption() {
      if (!variantSelectEnabled || !pendingVariantId) return;
      if (!pendingFromDropdown) return;
      if (oneTimeOption.classList.contains("loop-widget-purchase-option-selected")) return;

      vsLog("restoring one-time after Loop re-render");
      selectOption(oneTimeOption);
    }

    // subscriptions are always the first variant
    function enforceSubscriptionVariant() {
      if (!variantSelectEnabled) return;

      // a one-time pick is mid-flight; the re-render's default is not a choice
      if (pendingVariantId) return;

      if (!subOption.classList.contains("loop-widget-purchase-option-selected")) return;

      const first = SUBSCRIPTION_PREFERS_AVAILABLE
        ? (variantData.variants.find(v => v.available) || variantData.variants[0])
        : variantData.variants[0];

      if (!first || currentVariantId() === String(first.id)) return;

      selectVariantById(first.id);
    }

    mountVariantSelect();

    if (variantSelectEnabled) {
      // keep the dropdown honest if anything else moves the variant
      window.addEventListener(
        "theme:product:" + variantData.options_id + ":variantChanged",
        syncVariantSelect
      );
    }

    const toggleDescVisibility = () => {
      const isSubSelected = subOption.classList.contains("loop-widget-purchase-option-selected");
      oneTimeDescEl.style.display = isSubSelected ? "none" : "flex";
      subDescEl.style.display = isSubSelected ? "flex" : "none";
    };

    // ----- PRODUCT MEDIA SWITCHER ----- reversed the images on dec 17, 2025
    const mainGallery = document.querySelector('.main-product--desktop:not([data-type])');
    const optionalGallery = document.querySelector('.main-product--desktop[data-type="optional"]');
    const travelGallery = document.querySelector('.main-product--desktop[data-type="travel"]');
    const mainGalleryMobile = document.querySelector('.main-product--mobile:not([data-type])');
    const optionalGalleryMobile = document.querySelector('.main-product--mobile[data-type="optional"]');
    const travelGalleryMobile = document.querySelector('.main-product--mobile[data-type="travel"]');
    const subBtn = document.querySelector('.product-buy-buttons--primary:not([disabled]) .product-buy-buttons--cta-text');

    // only run switching logic if optional gallery exists
    const hasOptionalGallery = optionalGallery !== null;

    /* Swap the gallery with the purchase option on any product that has the
       alternate images set - the pairing the Starter Bundle has used since the
       images were reversed on dec 17, 2025. Both galleries only exist when
       product.metafields.custom.product_images_one_time_purchase is filled in
       (see main-product.liquid), so hasOptionalGallery is the "is this
       configured" check and nothing happens without it. */
    function updateGalleryBasedOnSelection() {
      if (!hasOptionalGallery) return;

      /* The variant's own media owns the gallery on these products. The
         optional gallery is built from file references with no media ids, so it
         can never show per-variant images - the two features cannot both run on
         one product. Don't set both metafields on the same product. */
      if (variantSelectEnabled) {
        if (!warnedGalleryConflict) {
          warnedGalleryConflict = true;
          console.warn(
            "%cLoop custom logics", "background:#000;color:#fff;",
            "This product has both custom.variant_selector and "
            + "custom.product_images_one_time_purchase set. Per-variant images win; "
            + "the one-time/subscribe gallery swap is off. Clear one of the two."
          );
        }
        return;
      }

      const isSubSelected = subOption.classList.contains("loop-widget-purchase-option-selected");

      const swap = (main, optional) => {
        if (main) main.style.display = isSubSelected ? "none" : "";
        if (optional) optional.style.display = isSubSelected ? "" : "none";
      };

      swap(mainGallery, optionalGallery);
      swap(mainGalleryMobile, optionalGalleryMobile);

      // the Starter Bundle also swaps its free-gift banner, badge and CTA copy
      if (productType !== "Starter Bundle") return;

      freeGift.style.display = isSubSelected ? "" : "none";
      badge.style.display = isSubSelected ? "" : "none";

      if (isSubSelected && subBtn) subBtn.textContent = "try it now";
    }

    /* ----- TRAVEL-SIZE GALLERY -----

       Per-variant featured_media turned out not to be reliably assigned on this
       store, and the Travel images are not product media at all - they are file
       references in custom.variant_travel_images. File references carry no media
       id and serve from a different CDN path, so there is no dependable way to
       match one to an item in the real gallery.

       So Travel gets its own gallery (main-product.liquid renders it with the
       same snippet as the one-time gallery) and the two are swapped wholesale:
       Travel shows only the metafield images, Standard shows only the real
       gallery. filterGalleryMedia still runs on the Standard side, so a Travel
       variant that DOES have its own media stays hidden there too. */
    const hasTravelGallery = !!(travelGallery || travelGalleryMobile);

    function isTravelVariant(variant) {
      if (!variant) return false;

      /* Positional, matching VARIANT_LABELS: index 0 is Standard, anything
         after it is a Travel size. */
      return variantData.variants.findIndex(v => String(v.id) === String(variant.id)) > 0;
    }

    function updateVariantGallery(variant) {
      if (!variantSelectEnabled || !hasTravelGallery) return;

      const travel = isTravelVariant(variant);

      const show = (el, visible) => {
        if (el) el.style.display = visible ? "" : "none";
      };

      show(travelGallery, travel);
      show(travelGalleryMobile, travel);
      show(mainGallery, !travel);
      show(mainGalleryMobile, !travel);

      vsLog("travel gallery", { travel, variant: variant && variant.id });

      publishHeroImage(travel);
    }

    /* The mobile drawer's 60x60 header image is seeded once when the drawer is
       built and never touched again, so it has to be told. Both files wait
       independently on the Loop widget and either can win, hence the replay
       value alongside the event. */
    let lastHeroSrc = null;

    function publishHeroImage(travel) {
      const scope = travel
        ? (travelGalleryMobile || travelGallery)
        : (mainGalleryMobile || mainGallery);

      if (!scope) return;

      const img = scope.querySelector(
        ".product-media--root:not(." + VARIANT_MEDIA_HIDDEN + ") img"
      );

      const src = img && (img.currentSrc || img.src);
      if (!src || src === lastHeroSrc) return;   // updateOptions runs often

      lastHeroSrc = src;
      window.__riniHeroSrc = src;
      window.dispatchEvent(new CustomEvent("rini:hero-image", { detail: { src } }));

      vsLog("hero image", { travel, src });
    }

    // show the 3 gifts only while the subscription option is selected
    function updateGiftsBasedOnSelection() {
      if (!isThreeGifts) return;

      const isSubSelected = subOption.classList.contains("loop-widget-purchase-option-selected");
      freeGift.style.display = isSubSelected ? "grid" : "none";
    }

    // ----- 3-gift pricing -----
    // Prices are read out of the rendered DOM rather than from fixed Loop
    // class names, so a widget markup change degrades instead of breaking.
    const isStruck = el => {
      if (el.closest("s, del")) return true;
      for (let node = el; node && node !== subOption.parentNode; node = node.parentElement) {
        const decoration = getComputedStyle(node).textDecorationLine || getComputedStyle(node).textDecoration || "";
        if (decoration.indexOf("line-through") !== -1) return true;
      }
      return false;
    };

    // Loop's own "hidden" utility. A price behind it is still in the markup, so
    // it has to be skipped here or it gets mistaken for a rendered price.
    const LOOP_HIDDEN_CLASS = "loop-display-none";

    function readOptionPrices(optionEl) {
      const nodes = Array.from(optionEl.querySelectorAll("*")).filter(el => {
        if (el.children.length) return false;                        // leaf nodes only
        if (el.closest(".loop-desc-wrapper, .loop-freegift, .loop-gifts-topbar")) return false;
        if (el.closest("." + LOOP_HIDDEN_CLASS)) return false;
        return MONEY_RE.test(el.textContent);
      });

      let compare = null;
      let current = null;

      nodes.forEach(el => {
        const money = parseMoney(el.textContent);
        if (!money) return;
        if (isStruck(el)) { if (!compare) compare = { el, money }; }
        else if (!current) current = { el, money };
      });

      return { compare, current };
    }

    let lastSavePct = null;
    let lastRecurringPct = null;

    function updateGiftPricing() {
      const subPrices = readOptionPrices(subOption);
      const current = subPrices.current;
      if (!current) return;

      const compare = subPrices.compare;
      const symbol = (compare && compare.money.symbol) || current.money.symbol;

      // the compare-at price on its own, gift value NOT included - this is what
      // the recurring saving is measured against
      let compareBase = compare ? compare.money.amount : null;

      const addGiftValue = isThreeGifts
        && THREE_GIFTS_CONFIG.addGiftValueToComparePrice
        && giftsTotal > 0;

      if (addGiftValue) {
        let compareEl = compare && compare.el;

        if (!compareEl) {
          // widget renders no struck price - build one off the one-time price
          const oneTimePrices = readOptionPrices(oneTimeOption);
          const base = oneTimePrices.compare || oneTimePrices.current;
          if (!base) return;

          compareEl = subOption.querySelector(".loop-gifts-compare");
          if (!compareEl) {
            compareEl = document.createElement("span");
            compareEl.className = "loop-gifts-compare";
            current.el.parentNode.insertBefore(compareEl, current.el);
          }
          compareBase = base.money.amount;
        } else {
          // idempotent: don't add the gift total twice when nothing re-rendered
          const appliedBase = parseFloat(compareEl.getAttribute("data-loop-gift-base"));
          const shown = parseMoney(compareEl.textContent);
          const alreadyApplied = !isNaN(appliedBase) && shown &&
            Math.abs(shown.amount - (appliedBase + giftsTotal)) < 0.005;

          compareBase = alreadyApplied ? appliedBase : compare.money.amount;
        }

        const nextText = formatMoney(compareBase + giftsTotal, symbol);
        if (compareEl.textContent.trim() !== nextText) compareEl.textContent = nextText;
        compareEl.setAttribute("data-loop-gift-base", String(compareBase));
      }

      // first order is discounted against compare-at + gifts, recurring orders
      // only against compare-at
      const compareAmount = addGiftValue ? compareBase + giftsTotal : compareBase;

      // "SAVE x%" bar + first bullet
      if (!compareAmount || compareAmount <= current.money.amount) return;

      const savePct = (1 - current.money.amount / compareAmount) * 100;

      const recurringPct = compareBase > current.money.amount
        ? (1 - current.money.amount / compareBase) * 100
        : null;

      /* Parked for updateOneTimeDesc(): the one-time card names the discount it
         is NOT getting, and this is the same figure the subscribe card shows as
         "x% off recurring". Held outside the early-return below so a pass that
         stops on the unchanged-price guard keeps the last good value. */
      lastRecurringPct = recurringPct;

      if (lastSavePct !== null && Math.abs(savePct - lastSavePct) < 0.05) return;
      lastSavePct = savePct;

      giftsSaveEl.innerHTML = `Save <b>${formatPercent(savePct)}%</b>`;

      // only the 3-gift card's bullets carry the live figures
      if (isThreeGifts) subDescEl.innerHTML = buildGiftsSubDesc(savePct, recurringPct);
    }

    /* The one-time card's discount, measured against its own struck price.
       readStruckBase() is used rather than the compare node directly so a row
       we rewrote in place reports the price before any gift value was added. */
    function updateOneTimeDesc() {
      const prices = readOptionPrices(oneTimeOption);
      const current = prices.current;
      const base = readStruckBase(prices);

      const oneTimePct = current && base && base > current.money.amount
        ? (1 - current.money.amount / base) * 100
        : null;

      const html = buildOneTimeDesc(oneTimePct, lastRecurringPct);

      // idempotent: this sits inside the widget, so a blind write would feed
      // the MutationObserver that calls us
      if (oneTimeDescEl.innerHTML !== html) oneTimeDescEl.innerHTML = html;
    }

    // The theme's own price block holds the selected variant's compare-at price
    // and keeps it in sync on variant change. Scoped to the block so the mobile
    // drawer's copy of the same markup is not picked up.
    function readThemeComparePrice() {
      const el = document.querySelector(
        '.product-form--block[data-block-type="price"] .product-price--compare'
      );

      if (!el || el.getAttribute("aria-hidden") === "true") return null;

      const money = parseMoney(el.textContent);
      return money ? money.amount : null;
    }

    // The struck price a card is showing, with any gift value we added stripped
    // back off. Works for a price the widget struck itself, one we rewrote in
    // place (the base is parked on data-loop-gift-base), and one we injected.
    function readStruckBase(prices) {
      if (!prices.compare) return null;

      const applied = parseFloat(prices.compare.el.getAttribute("data-loop-gift-base"));
      return isNaN(applied) ? prices.compare.money.amount : applied;
    }

    // The compare-at price for the one-time card. The theme's price block is the
    // authoritative source, but it is not always rendered - the widget striking
    // a price on the subscribe card tells us the same number.
    function readOneTimeCompare() {
      const fromTheme = readThemeComparePrice();
      if (fromTheme) return fromTheme;

      return readStruckBase(readOptionPrices(subOption));
    }

    // Loop does render the compare-at price on the one-time card, it just keeps
    // it behind loop-display-none. Unhiding its own markup is better than
    // injecting a duplicate - it keeps the widget's money formatting.
    // The revealed node is tagged so it reads as a struck price, which the
    // hidden original has no styling for.
    function revealOneTimeCompare(current) {
      const scope = oneTimeOption.querySelector(".loop-widget-purchase-option-price-container")
        || oneTimeOption;

      let revealed = false;

      Array.from(scope.querySelectorAll("." + LOOP_HIDDEN_CLASS)).forEach(el => {
        const text = el.textContent.trim();

        const money = parseMoney(text);
        if (!money || money.amount <= current.money.amount) return;

        // the node must BE the price, not a block that happens to contain one
        if (text.replace(MONEY_RE, "").trim()) return;

        el.classList.remove(LOOP_HIDDEN_CLASS);
        if (!el.children.length) el.classList.add("loop-gifts-compare--revealed");
        revealed = true;
      });

      return revealed;
    }

    // The widget renders a single price on the one-time option. When the variant
    // has a higher compare-at price, mirror it in as a struck price.
    function updateOneTimeCompare() {
      if (!isThreeGifts) return;

      const prices = readOptionPrices(oneTimeOption);
      const current = prices.current;
      if (!current || !current.el.parentNode) return;

      // prefer Loop's own compare-at node over anything we build
      if (revealOneTimeCompare(current)) return;

      let compareEl = oneTimeOption.querySelector(".loop-gifts-compare");

      // the widget renders a struck price of its own - leave it alone
      if (prices.compare && prices.compare.el !== compareEl) {
        if (compareEl) compareEl.remove();
        return;
      }

      const compareAmount = readOneTimeCompare();

      if (!compareAmount || compareAmount <= current.money.amount) {
        if (compareEl) compareEl.remove();
        return;
      }

      if (!compareEl) {
        compareEl = document.createElement("span");
        compareEl.className = "loop-gifts-compare";
        current.el.parentNode.insertBefore(compareEl, current.el);
      }

      const nextText = formatMoney(compareAmount, current.money.symbol);
      if (compareEl.textContent.trim() !== nextText) compareEl.textContent = nextText;
    }

    /* Single products: the subscribe card reads compare-at x qty (struck)
       against subscription price x qty. The compare-at comes from the theme's
       price block; a variant without one falls back to its one-time price, which
       is what Loop strikes on this card anyway. Runs last in updateOptions() so
       every other reader has seen Loop's own figures first. */
    function renderSubscribeTotals() {
      if (!subShowsTotals || bundlePricesOwned()) return;

      const priceEl = loopPriceOf(subOption);
      const unit = readUnitMoney(priceEl);
      if (!unit) return;

      writeSubMoney(priceEl, unit.amount, unit.symbol);

      const struckEl = loopStruckOf(subOption);
      if (!struckEl) return;

      const oneTime = readOptionPrices(oneTimeOption).current;
      const loopStruck = readUnitMoney(struckEl);

      const compareUnit = readThemeComparePrice()
        || (oneTime && oneTime.money.amount)
        || (loopStruck && loopStruck.amount);

      if (!compareUnit || compareUnit <= unit.amount) return;

      writeSubMoney(struckEl, compareUnit, unit.symbol);
      struckEl.classList.remove("loop-display-none");
    }

    // The widget labels the subscribe option "Subscribe • Save 19.4%". The bar
    // above the card already states the saving, so the label is trimmed back to
    // just "Subscribe" on every product.
    const SAVE_PCT_RE = /save\b[^%]*%/i;
    const SAVE_SUFFIX_RE = /\s*[•·|]\s*save\b[\s\S]*$/i;
    const SEPARATOR_SUFFIX_RE = /\s*[•·|]\s*$/;

    // Our own copy quotes savings too, so those subtrees are always skipped
    const TRIM_SKIP = ".loop-desc-wrapper, .loop-freegift, .loop-gifts-topbar";

    function trimSubLabelSaving() {
      /* Scoped to the whole subscribe card rather than the label element: Loop
         renders the saving in a sibling of the label, not inside it, so a
         narrower scope left "subscribe • save 22%" untouched. Nothing else in
         the card reads as "save ...%", and our own copy is excluded above. */
      Array.from(subOption.querySelectorAll("*")).forEach(el => {
        if (el.children.length) return;                  // leaf nodes only
        if (el.closest(TRIM_SKIP)) return;

        const text = el.textContent.trim();
        if (!SAVE_PCT_RE.test(text)) return;

        /* Hide only a node that is nothing BUT the saving. Where Loop puts the
           whole label in one node ("subscribe - save 22%"), hiding it would
           take the word "subscribe" with it, so that case is left to the text
           pass below, which strips the saving and keeps the rest. */
        if (text.replace(SAVE_PCT_RE, "").replace(/^[\s•·|]+|[\s•·|]+$/g, "")) return;

        hide(el);
      });

      // ...and the same again for loose text, plus the separator that hiding
      // the saving leaves stranded ("subscribe •")
      const walker = document.createTreeWalker(subOption, NodeFilter.SHOW_TEXT);
      const texts = [];

      while (walker.nextNode()) texts.push(walker.currentNode);

      texts.forEach(node => {
        if (node.parentElement && node.parentElement.closest(TRIM_SKIP)) return;

        const next = node.nodeValue
          .replace(SAVE_SUFFIX_RE, "")
          .replace(SEPARATOR_SUFFIX_RE, "");

        if (next !== node.nodeValue) node.nodeValue = next;
      });
    }

    // --- Debounced update logic ---
    let updateTimer;
    function updateOptionsDebounced() {
      clearTimeout(updateTimer);
      updateTimer = setTimeout(updateOptions, 100); // small delay fixes race
    }

    function updateOptions() {
      qtyInput = Array.from(document.querySelectorAll('input[name="quantity"]'))
        .find(input => input.offsetParent !== null);

      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      show(subOption);
      show(oneTimeOption);

      if (productType == "Single") {
        const isSubSelected = subOption.classList.contains("loop-widget-purchase-option-selected");
        // revert when manually reduced below the subscription minimum
        if (isSubSelected && qty < subMinQty) {
          selectOption(oneTimeOption);
        }
      } else if (productType == "Bundle") {
        show(subOption); show(oneTimeOption);
      } else if (productType == "Starter Bundle") {
        show(subOption); show(oneTimeOption); toggleDescVisibility();
      } else if (isThreeGifts) {
        show(subOption); show(oneTimeOption); toggleDescVisibility();
      } else if (productType == "Bundle with subscription only") {
        hide(oneTimeOption); show(subOption); selectOption(subOption);
      }

      updateGalleryBasedOnSelection();
      mountTopBar();
      mountVariantSelect();
      restorePurchaseOption();
      enforceSubscriptionVariant();
      syncVariantSelect();

      /* Loop repaints its rows on its own schedule; put the variant's figures
         back each time the widget settles.

         Prefer the pending pick over input[name="id"]: the theme's section
         refetch is async, so straight after a pick that input still reports the
         OLD variant - reading it here wrote the old prices back over the new
         ones, which is why the first pick never took. */
      if (variantSelectEnabled) {
        captureSubscriptionRatio();

        const shown = pendingVariantId || currentVariantId();
        const shownVariant = variantData.variants.find(v => String(v.id) === shown);

        renderLoopVariantPrices(shownVariant);
        filterGalleryMedia(shownVariant);   // re-applied: the gallery can re-render
        updateVariantGallery(shownVariant);
      }
      updateGiftsBasedOnSelection();
      // before updateGiftPricing() - it reads the one-time option's struck price
      // as the baseline for the subscribe card
      updateOneTimeCompare();
      updateGiftPricing();
      updateOneTimeDesc();   // after updateGiftPricing() - it sets lastRecurringPct
      updateSingleSubDesc();
      trimSubLabelSaving();
      renderSubscribeTotals();   // last - the savings above are read off the same row
      window.dispatchEvent(new CustomEvent('bundle:update'));
    }

    // --- Hover + click logic for Single ---
    if (productType == "Single") {
      const subLabelEl = subOption.querySelector(".loop-widget-purchase-option-label");
      const originalText = subLabelEl ? subLabelEl.textContent : "";

      subOption.addEventListener("mouseenter", () => {
        if (subLabelEl) subLabelEl.textContent = `buy ${subMinQty}+ to subscribe`;
      });
      subOption.addEventListener("mouseleave", () => {
        if (subLabelEl) subLabelEl.textContent = originalText;
      });

      subOption.addEventListener("click", () => {
        qtyInput = Array.from(document.querySelectorAll('input[name="quantity"]'))
          .find(input => input.offsetParent !== null);
        const qty = parseInt(qtyInput.value, 10) || 1;

        if (qty < subMinQty) {
          qtyInput.value = subMinQty;
          qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
          qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
          console.log("%cLoop custom logics", "background:#000;color:#fff;", `Qty auto-adjusted to ${subMinQty} for subscription`);
        }
      });

      /* Back to one-time drops the quantity to 1. Shopper clicks only: our own
         selectOption(oneTimeOption) - the revert when qty falls below the
         minimum, the shared Travel link - is a synthetic click and must keep
         the quantity it was given. The size dropdown sits inside this card, so
         using it is not choosing one-time either. */
      oneTimeOption.addEventListener("click", event => {
        if (!event.isTrusted || variantWrap.contains(event.target)) return;
        if (oneTimeOption.classList.contains("loop-widget-purchase-option-selected")) return;

        qtyInput = Array.from(document.querySelectorAll('input[name="quantity"]'))
          .find(input => input.offsetParent !== null);

        if (!qtyInput || qtyInput.value === "1") return;

        qtyInput.value = 1;
        qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
        qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
      }, true);
    }

    /* The other half of redirectSharedTravelLink(): the page is now on the main
       variant, so Loop has rendered both cards - pick the one-time card and
       the shared size. One-time is clicked FIRST, because the capture listener
       on the cards clears any pending pick. fromDropdown keeps
       restorePurchaseOption() holding one-time if Loop re-renders onto
       subscribe. The theme's updateHistoryState then rewrites the URL to
       ?variant=<travel>, dropping TRAVEL_PARAM. */
    function applySharedTravelSelection() {
      if (!variantSelectEnabled) return;

      const travelId = new URL(location.href).searchParams.get(TRAVEL_PARAM);
      if (!travelId) return;

      const variant = variantData.variants.find(v => String(v.id) === travelId);

      if (!variant || !variant.available) {
        vsLog("shared travel ignored", { travelId, found: !!variant });
        return;
      }

      selectOption(oneTimeOption);
      selectVariantById(variant.id, true);

      vsLog("shared travel applied", { id: variant.id });
    }

    // --- Bindings ---
    updateOptions();
    applySharedTravelSelection();

    /* Delegated, not bound to the nodes: mobile-buy-drawer.js borrows the form
       and replaces the +/- buttons with clones (resetQuantityButtons), which
       drops any listener bound to them - so on mobile a "-" below the minimum
       only reverted to one-time when something else happened to re-run
       updateOptions. The theme's buttons set input.value without firing
       input/change, so the click is the only signal. Capture phase, so a
       handler that stops propagation can't hide it; the delay lets the theme
       write the new value first. */
    const isQtyInput = el => el && el.matches && el.matches('input[name="quantity"]');

    document.addEventListener("input", e => { if (isQtyInput(e.target)) updateOptionsDebounced(); }, true);
    document.addEventListener("change", e => { if (isQtyInput(e.target)) updateOptionsDebounced(); }, true);

    document.addEventListener("click", e => {
      if (!e.target.closest || !e.target.closest(".quantity-selector--plus, .quantity-selector--minus")) return;
      setTimeout(updateOptionsDebounced, 100);
    }, true);

    // bundleSelector.js overwrites the widget's unit prices with pack totals.
    // Recompute once it has, so the "SAVE x%" bar quotes the pack's saving and
    // matches the percentage on the pack's own badge.
    window.addEventListener("bundle:ready", updateOptionsDebounced);

    const observerQty = new MutationObserver(updateOptionsDebounced);
    if (qtyInput) observerQty.observe(qtyInput, { attributes: true, attributeFilter: ["value"] });

    const observer = new MutationObserver(() => {
      updateOptionsDebounced();
      qtyInput = Array.from(document.querySelectorAll('input[name="quantity"]'))
        .find(input => input.offsetParent !== null);
    });
    observer.observe(loopContainer, { childList: true, subtree: true });
  });
});